import React, { useEffect, useState } from "react";
import AppContext from "./appcontext";
import Cookie from "js-cookie";
import { updateServiceData } from "../redux/serviceSlice";
import { useDispatch } from "react-redux";
import {
  httpGetUIEnv,
  httpGetUserPermission,
  httpGetWorkflowSteps,
} from "../service/httpClient";
import { Spinner } from "react-bootstrap";
import { LicenseManager } from "ag-grid-enterprise";

const GlobalState = (props) => {
  const dispatch = useDispatch();

  const [state, setState] = useState({
    fetching: true,
    roles: JSON.parse(localStorage.getItem("roles")),
    rightNotes: [],
    workflowSteps: [],
  });

  useEffect(() => {
    if (Cookie.get("email")) {
      //Get UI Environment Variables
      //Removes dependency on environment variable in
      // case of an error preventing the UI from crashing
      
      Promise.all([
        getUserPermission(Cookie.get("email").toLowerCase()),
        getWorkflowSteps(),
        getEnv(),
      ])
        .then(([userPermission, workflowSteps, uiEnv]) => {
          localStorage.setItem("reload_count", 0);
          if (userPermission && workflowSteps) {
            setState((state) => ({
              ...state,
              roles: { ...userPermission, userName: Cookie.get("userName") },
              workflowSteps,
              UI_ENV: { ...uiEnv },
            }));
            dispatch(
              updateServiceData({
                workflowSteps,
                roles: { ...userPermission, userName: Cookie.get("userName") },
                UI_ENV: { ...uiEnv },
              })
            );
          }
        })
        .catch((error) => {
          console.log("Unable to get user permissions or workflow statuses");
        })
        .finally(() => {
          setFetching();
        });
    } else {
      setFetching();
    }
  }, []);

  const setRightNotes = (rightNotes) => {
    setState((state) => ({
      ...state,
      rightNotes,
    }));
  };

  const setRedirect = () => {
    Cookie.set(
      "redirectTo",
      (window.location.pathname + window.location.search).substr(1),
      { secure: true }
    );
    if (!Cookie.get("userName")) {
      window.location = "/";
    }
  };

  const setFetching = () => {
    setState((state) => ({
      ...state,
      fetching: false,
    }));
  };

  const getUserPermission = (emailId) => {
    let userDetails = {
      email: emailId,
      userType: Cookie.get("userType"),
      userName: Cookie.get("userName"),
    };

    return httpGetUserPermission(userDetails).then((res) => {
      localStorage.setItem("roles", JSON.stringify(res.data));
      return res.data;
    });
  };

  const getEnv = () =>
    httpGetUIEnv()
      .then((res) => {
        /*dispatch(
          updateServiceData({
            UI_ENV: { ...res.data },
          })
        );*/
        LicenseManager.setLicenseKey(res.data.AGGRID_LICENSE_KEY);
        return res.data;
      })
      .catch((error) => console.log(error));

  const getWorkflowSteps = () => {
    let workflowSteps = {};
    return httpGetWorkflowSteps().then((res) => {
      res.data.forEach((item) => {
        const {
          statusName,
          statusForVendorTypes,
          statusOwner,
          statusOrder,
        } = item;
        workflowSteps = {
          ...workflowSteps,
          [statusName]: statusForVendorTypes,
          [`${statusName}StatusOwner`]: statusOwner
            ? statusOwner.split(",")
            : [],
          [`${statusName}StatusOrder`]: parseInt(statusOrder) || 0,
        };
      });
      return workflowSteps;
    });
  };

  if (state.fetching) {
    return (
      <Spinner
        animation="border"
        variant="danger"
        style={{
          width: "50px",
          height: "50px",
          marginRight: 5,
          position: "absolute",
          top: "40vh",
          left: "50vw",
        }}
      />
    );
  }

  return (
    <AppContext.Provider
      value={{
        state,
        roles: state.roles,
        onRedirectHandler: setRedirect,
        rightNotes: state.rightNotes,
        setRightNotes: setRightNotes,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};

export default GlobalState;
